export default {
  'account-service.login.success': 'Successfully logged in',
  'account-service.logout.success': 'Successfully logged out',
  'api.error.account_has_left_the_pool_already': 'This account has left the pool already!',
  'api.error.account_has_left_the_pool_forever': 'This account has left the pool forever, can not rejoin!',
  'api.error.account_has_not_left_the_pool': 'This account has not left the pool yet!',
  'api.error.account_is_cheating': 'This account is banned for cheating, can not leave the pool!',
  'api.error.account_not_found': 'The account was not found.',
  'api.error.difficulty_update_rate_limited': 'Slow down, you are updating the difficulty too often!',
  'api.error.distribution_ratio_changed_recently': 'The distribution ratio was changed recently, please allow up to 2h before trying again.',
  'api.error.invalid_distribution_ratio': 'The distribution ratio is invalid!',
  'api.error.invalid_message': 'The message is invalid!',
  'api.error.invalid_minimum_payout': 'The minimum payout amount is invalid!',
  'api.error.invalid_name': 'The name is invalid!',
  'api.error.invalid_notification_settings': 'The provided notification settings are invalid!',
  'api.error.invalid_signature': 'The signature is invalid!',
  'api.error.invalid_authentication_token': 'The authentication token is invalid!',
  'api.error.invalid_payout_multiples_of': 'The payout multiples of amount is invalid!',
  'api.error.invalid_token': 'The login link is invalid, already used or expired!',
  'api.error.invalid_image_url': 'The image url is invalid!',
  'api.error.invalid_partials_per_hour': 'The partials per hour value is invalid!',
  'authentication-modal.authenticate': 'Authenticate',
  'authentication-modal.authenticating': 'Authenticating',
  'authentication-modal.authentication-guide': 'For a list of detailed steps please follow <a href="{1}" target="_blank">the guide</a> on how to authenticate yourself.',
  'authentication-modal.authentication-info': 'To sign the message first obtain the fingerprint of your wallet via<br><code>{1} keys show</code><br>and then execute the following command:<br><code>{1} keys sign -t "{2}" -d {3} -f &lt;your fingerprint here&gt;</code>',
  'authentication-modal.message-to-sign': 'The message to sign',
  'authentication-modal.signature-placeholder': 'Signature',
  'authentication-modal.success': 'Successfully authenticated',
  'authentication-modal.title': 'Authenticate',
  'blocks-won-component.blocks-won-in-the-last-24h': '{1} in the last 24h',
  'blocks-won-component.distributed': 'Distributed',
  'blocks-won-component.header.date': 'Date',
  'blocks-won-component.header.distributed': 'Distributed',
  'blocks-won-component.header.effort': 'Effort',
  'blocks-won-component.header.height': 'Height',
  'blocks-won-component.header.network-capacity': 'Netspace',
  'blocks-won-component.header.reward': 'Reward',
  'blocks-won-component.header.winner': 'Winner',
  'blocks-won-component.no-blocks-won-yet': 'No blocks won yet!',
  'blocks-won-component.pending': 'Pending',
  'blocks-won-component.in-mempool': 'In Mempool',
  'blocks-won-component.title': 'Recently won Blocks',
  'blocks-won-component.unclaimed': 'Unclaimed',
  'dashboard-component.latest-notices.title': 'Latest notices',
  'download-csv-button.title': 'Download CSV',
  'events-component.block-winner-extra-reward.title': 'Block winner extra rewards',
  'events-component.ended-at': 'Ended at',
  'events-component.extra-block-reward.title': 'Extra block rewards',
  'events-component.extra-reward': 'Extra reward',
  'events-component.filled': 'Filled',
  'events-component.started-at': 'Started at',
  'events-component.state': 'State',
  'events-component.states.active': 'Active',
  'events-component.states.ended': 'Ended',
  'events-component.states.upcoming': 'Upcoming',
  'events-component.title': 'Events',
  'events-component.will-start': 'Will start',
  'farmer-payout-history-component.chart.amount.name': 'Amount',
  'faucet-component.binding-help-text': 'Use the "{1}" function in your wallet to bind to the pool ({2})',
  'faucet-component.errors.missing-address': 'No address entered!',
  'faucet-component.get-coins-to-bind': 'Get coins to bind',
  'faucet-component.input.address': 'Address',
  'faucet-component.pool-address': 'Pool address',
  'general.all': 'All',
  'general.cancel': 'Cancel',
  'general.copy': 'Copy',
  'general.distribution-ratio': 'Distribution ratio',
  'general.avg-ec': 'Average Effective Capacity',
  'general.error': 'Error: {1}',
  'general.failure': 'Failure: {1}',
  'general.not-available.short': 'N/A',
  'general.success': 'Success!',
  'general.unknown': 'Unknown',
  'header-component.button.blocks-won': 'Blocks won',
  'header-component.button.dashboard': 'Dashboard',
  'header-component.button.events': 'Events',
  'header-component.button.faucet': 'Faucet',
  'header-component.button.info': 'Info',
  'header-component.button.logout': 'Logout',
  'header-component.button.my-farmer': 'My Farmer',
  'header-component.button.notices': 'Notices',
  'header-component.button.other-pools': 'Other Pools',
  'header-component.button.payouts': 'Payouts',
  'header-component.button.settings': 'Settings',
  'header-component.search.placeholder': 'Pool Public Key',
  'header-component.search.title': 'Search',
  'info-component.contact.join-discord': 'Join our <a href="https://discord.gg/foxypool" target="_blank">Discord</a>',
  'info-component.contact.title': 'Contact',
  'info-component.pool-info.distribution-delay-info': 'Block reward distribution is delayed by {1} blocks',
  'info-component.pool-info.block-split-info': 'Block reward split: 1/8 to the block finder (farmer reward), 7/8 to the pool members (pool reward) with configurable DR',
  'info-component.pool-info.payout.fee-info': '{1}% fee, free automatic payouts',
  'info-component.pool-info.payout.interval-info': 'Payouts happen once per day at 12:00 UTC',
  'info-component.pool-info.payout.minimum-info': 'Minimum amount for payouts is {1} {2}, every Sunday the minimum amount is ignored unless a custom minimum payout is set',
  'info-component.pool-info.pplns-info': 'PPLNS over the last {1} hours',
  'info-component.pool-info.title': 'Pool info',
  'info-component.using-this-pool.title': 'Using this pool',
  'leave-pool-modal.collateral-warning': 'Warning! This can not be reverted, rejoining the pool is not possible after paying out the collateral balance!',
  'leave-pool-modal.leave': 'Leave',
  'leave-pool-modal.leave-forever': 'Pay out my collateral balance',
  'leave-pool-modal.leaving': 'Leaving',
  'leave-pool-modal.leaving-info-toast': 'Leaving the pool takes about a minute or two, please wait',
  'leave-pool-modal.read-leave-guide-info': 'Please read the guide on how to properly leave the pool <a href="{1}" target="_blank">here</a>.<br><br><strong>The pool will not reimburse you any rewards sent to the pools address!</strong>',
  'leave-pool-modal.rejoin-info': 'You can rejoin at any time after leaving the pool',
  'leave-pool-modal.success': 'Successfully left the pool',
  'leave-pool-modal.title': 'Are you sure you want to leave the pool?',
  'my-farmer-component.collateral-balance-card.title': 'Collateral balance',
  'my-farmer-component.collateral-balance-card.help': 'The collateral balance is a anti-cheater measure which will hold the first pool block reward portion amount of your rewards as a collateral on the pool. The collateral can get paid out when permanently leaving the pool or after two years, whichever comes first.',
  'my-farmer-component.difficulty-card.title': 'Difficulty',
  'my-farmer-component.ec-card.help': 'The average effective capacity (EC) is calculated based on the last 24h of partials submitted to the pool.',
  'my-farmer-component.last-partial-accepted-card.title': 'Last Partial accepted',
  'my-farmer-component.login-button.label': 'Login',
  'my-farmer-component.login-button.label-logging-in': 'Logging in',
  'my-farmer-component.manage-account-card.action.leave-pool': 'Leave Pool',
  'my-farmer-component.manage-account-card.action.rejoin-pool': 'Rejoin Pool',
  'my-farmer-component.manage-account-card.action.update-minimum-payout': 'Set min payout',
  'my-farmer-component.manage-account-card.action.update-name': 'Update Name',
  'my-farmer-component.manage-account-card.authenticate': 'Authenticate',
  'my-farmer-component.manage-account-card.authenticated': 'Authenticated',
  'my-farmer-component.manage-account-card.title': 'Manage Account',
  'my-farmer-component.name-card.title': 'Name',
  'my-farmer-component.payout-address-card.title': 'Payout Address',
  'my-farmer-component.pending-balance-card.title': 'Pending balance',
  'my-farmer-component.rejoin-pool.success': 'Successfully rejoined the pool',
  'my-farmer-component.ec-chart.title': 'Effective Capacity',
  'my-farmer-component.shares-chart.title': 'Shares',
  'my-farmer-component.shares-chart.shares.name': 'Shares',
  'my-farmer-component.shares-chart.valid-shares.name': 'Valid Shares',
  'my-farmer-component.shares-chart.invalid-shares.name': 'Invalid Shares',
  'my-farmer-component.shares-chart.stale-shares.name': 'Stale Shares',
  'my-farmer-component.shares-chart.difficulty.name': 'Difficulty',
  'my-farmer-component.shares-chart.partials.name': 'Partials',
  'my-farmer-component.tabs.stats.label': 'Stats',
  'my-farmer-component.tabs.recent-payouts.label': 'Recent payouts',
  'my-farmer-component.tabs.won-blocks.label': 'Blocks',
  'notices-component.title': 'Notices',
  'payouts-component.headers.amount': 'Amount',
  'payouts-component.headers.fiat-amount': 'Fiat amount',
  'payouts-component.headers.date': 'Date',
  'payouts-component.headers.state': 'State',
  'payouts-component.headers.transaction': 'Transaction',
  'payouts-component.no-payouts-sent-yet': 'No payouts sent yet!',
  'payouts-component.title': 'Payouts',
  'payouts-component.confirmed': 'Confirmed',
  'payouts-component.partially-confirmed': 'Partially Confirmed',
  'payouts-component.in-mempool': 'In Mempool',
  'pool-history-component.chart.title': 'Pool History',
  'pool-history-component.chart.blocks.name': 'Blocks',
  'pool-history-component.chart.effort.name': 'Effort',
  'pool-history-component.chart.pool-ec.name': 'Pool EC',
  'pool-history-component.chart.capacity.name': 'Capacity',
  'pool-history-component.chart.network-capacity.name': 'Netspace',
  'routing.title-prefix.blocks-won': 'Blocks won',
  'routing.title-prefix.events': 'Events',
  'routing.title-prefix.faucet': 'Faucet',
  'routing.title-prefix.info': 'Info',
  'routing.title-prefix.notices': 'Notices',
  'routing.title-prefix.payouts': 'Payouts',
  'routing.title-prefix.settings': 'Settings',
  'routing.title-prefix.top-accounts': 'Top Accounts',
  'routing.title-prefix.my-farmer': 'My Farmer',
  'routing.title-prefix.farmer': 'Farmer',
  'routing.title-prefix.farmers': 'Farmers',
  'settings-component.actions.on-demand-payout.button': 'On demand payout',
  'settings-component.actions.on-demand-payout.help-text': 'Note: a {1} {2} flat fee is deducted from the on demand payout amount you specify. Minimum payout amount is {3} {2}.',
  'settings-component.actions.on-demand-payout.max': 'Max',
  'settings-component.actions.on-demand-payout.request-payout': 'Request payout',
  'settings-component.actions.on-demand-payout.success': 'Successfully requested a payout',
  'settings-component.actions.on-demand-payout.title': 'On demand payout',
  'settings-component.actions.set-account-name.account-name.placeholder': 'Account name',
  'settings-component.actions.set-account-name.button': 'Set account name',
  'settings-component.actions.set-account-name.save': 'Save',
  'settings-component.actions.set-account-name.success': 'Successfully set the account name',
  'settings-component.actions.set-account-name.title': 'Set account name',
  'settings-component.actions.set-distribution-ratio.button': 'Set distribution ratio',
  'settings-component.actions.set-distribution-ratio.help-text': 'Note: The distribution ratio defines how miner rewards are split. 0-100 gives 0% to the block winner and 100% to historical shares. 50-50 gives 50% to the block winner and 50% to historical shares. 100-0 gives 100% to the block winner and 0% to historical shares.',
  'settings-component.actions.set-distribution-ratio.save': 'Save',
  'settings-component.actions.set-distribution-ratio.success': 'Successfully set the distribution ratio',
  'settings-component.actions.set-distribution-ratio.title': 'Set distribution ratio',
  'settings-component.logged-in-with': 'Logged in with payout address {1}',
  'settings-component.logout': 'Logout',
  'settings-component.payout-address.placeholder': 'Your payout address',
  'settings-component.verification.button.label': 'Verify identity',
  'settings-component.verification.button.processing-label': 'Verifying identity',
  'settings-component.verification.message-to-sign': 'Message to sign',
  'settings-component.verification.public-key-input.label': 'Input your public key for verification',
  'settings-component.verification.public-key-input.placeholder': 'Your public key',
  'settings-component.verification.sign-it-here': 'Sign it here',
  'settings-component.verification.signature-input.label': 'Input your message signature for verification',
  'settings-component.verification.signature-input.placeholder': 'Message signature',
  'stats-card-component.average-effort': 'Average Effort',
  'stats-card-component.average-effort.help': 'The average effort is the pools effort calculated over the past 7 days based on actual vs. expected block wins. Lower than 100% is lucky, around 100% is normal and above 100% is unlucky.',
  'stats-card-component.daily-reward': 'Daily Reward',
  'stats-card-component.daily-reward.help': 'The daily reward is an estimate based on the average farming rewards of this pool over the past 7 days. It is calculated per pebibyte (PiB) of farming capacity.',
  'stats-card-component.farmers': 'Farmers',
  'stats-card-component.pool-ec': 'Pool EC',
  'stats-card-component.current-effort': 'Current Effort',
  'stats-card-component.current-effort.help': 'The current effort shows the effort since the last won block. The effort is given in percent, where 100% equals the pools estimated time to win.',
  'stats-card-component.height': 'Height',
  'stats-card-component.network-capacity': 'Netspace',
  'stats-card-component.network-difficulty': 'Network Difficulty',
  'top-accounts-component.headers.address': 'Address',
  'top-accounts-component.headers.capacity': 'Capacity',
  'top-accounts-component.headers.capacity.help-text': 'Reported capacity',
  'top-accounts-component.headers.deadlines': 'Deadlines',
  'top-accounts-component.headers.ec': 'EC',
  'top-accounts-component.headers.pending': 'Pending',
  'top-accounts-component.headers.pending.tooltip': 'Pending + Collateral',
  'top-accounts-component.headers.share': 'Share',
  'top-accounts-component.headers.share.help-text': 'Historical share',
  'top-accounts-component.no-miners-found': 'No accounts found!',
  'top-accounts-component.one-state.offline': 'No submissions within the last 6 rounds',
  'top-accounts-component.one-state.online': 'Online',
  'top-accounts-component.one-state.warning': 'No submissions within the last 3 rounds',
  'top-accounts-component.search.placeholder': 'Search',
  'top-accounts-component.title': 'Top Accounts',
  'update-name-modal.account-name': 'Account name',
  'update-name-modal.error.name-too-long': 'The name is too long.',
  'update-name-modal.remove-name': 'Remove name',
  'update-name-modal.remove-success': 'Successfully removed the name',
  'update-name-modal.title': 'Update the account name',
  'update-name-modal.update-name': 'Update name',
  'update-name-modal.update-success': 'Successfully updated the name to "{1}"',
  'update-name-modal.updating': 'Updating',
  'update-service.updating': 'Updating to the latest version ..',
};
